import { render, staticRenderFns } from "./MyCase.vue?vue&type=template&id=5e9f82c0&"
import script from "./MyCase.vue?vue&type=script&lang=js&"
export * from "./MyCase.vue?vue&type=script&lang=js&"
import style0 from "./MyCase.vue?vue&type=style&index=0&id=5e9f82c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports